import type { FooterLinks, LinkSegments, RankedCitiesData } from '$lib/components/seo/types';
import type { LanguageCode } from '$lib/i18n/language';
import { getSegmentsLabel, segments2route } from '$lib/components/seo/linkSegments';

function formatRankedCitiesToLinks(currentAddress: LinkSegments, { country, cities }: Pick<RankedCitiesData, 'country' | 'cities'>, lang: LanguageCode) {
	if (!cities.length || !country) {
		return [];
	}

	const currentCountry = currentAddress.at(0)?.label;

	if (currentCountry?.toLocaleLowerCase() !== country.toLocaleLowerCase()) {
		return [];
	}

	const currentCity = getSegmentsLabel(currentAddress);
	return cities
		.filter(({ label }) => label.toLocaleLowerCase() !== currentCity?.toLocaleLowerCase())
		.map(
			({ value, label }) => ({
				href: segments2route(currentAddress, [{ value, label }], lang),
				label: `${currentCity} - ${label}`,
			}),
		);
}

export function getRankedCitiesLinks(lang: LanguageCode, currentAddress?: LinkSegments, rankedCitiesData?: RankedCitiesData): FooterLinks | undefined {
	if (!rankedCitiesData?.cities.length || !currentAddress) {
		return undefined;
	}

	const { cities, country, title } = rankedCitiesData;

	return {
		label: title,
		links: formatRankedCitiesToLinks(currentAddress, { country, cities }, lang),
	};
}
